import {
    PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_BEGIN,
    PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
  } from '../constants'

export function reducer(state, action) {
    switch (action.type) {
      case PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          entregaUsados: state.entregaUsados.map((usado, idx) => {
            if (idx === action.data.usedCarIndex) {
              return {
                ...usado,
                pending: true,
                error: null,
              }
            } else {
              return usado
            }
          }),
        }
  
      case PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS: {

        const bonifMax = state?.nuevo?.precio_local

        const usedCarBonif = state?.entregaUsados?.filter( (_, index) => index !== action.data.usedCarIndex).map( car => {
            if (!car?.take_improvement_amount) return 0
            const bonifExtraPercentaje = state?.nuevo?.bonification?.taking_car_percentage
            const takingPrice = ( car.updatedTakePrice || car.original_price || car.auxOriginalPrice || car.appraisal )
        
            const discountNominalValue = Math.floor((Math.floor(takingPrice * bonifExtraPercentaje) / 100) / 1000) * 1000
            const price = car.take_improvement_amount - discountNominalValue
        
            return price <= 0 || !price ? 0 : price
        }).reduce((total, amount) => total + amount, 0) || 0

        const bonif = action.data?.isDeleted ? 0 : (action.data.bonificationAmount || 0) < 0 ? 0 : (action.data.bonificationAmount || 0)

        const entregaUsados = state.entregaUsados.map((usado, idx) => {
          if (idx === action.data.usedCarIndex) {
            // usa el valor de tasacion final si es que tiene
            const price = usado.appraisal || usado.original_price
            return {
              ...usado,
              ...action.data,
              pending: false,
              error: null,
              final_take_price: usado.updatedTakePrice ? usado.updatedTakePrice + bonif : price + bonif,
              take_improvement_amount: bonif
            }
          } else {
            return usado
          }
        })

        const bonificationLimit = bonifMax - usedCarBonif - (state?.special_discount || 0) - bonif

        // The request is success
        return {
          ...state,
          entregaUsados,
          bonificationLimit,
          bonificationData: {
            ...state.bonificationData,
            bonificationLimit,
            bonificationAvailable: bonificationLimit,
          },
        }}
  
      default:
        return state
    }
  }
  